import { memo } from "react";
import { HorizontalDivider } from "./HorizontalDivider";

type ActionItemHorizontalDividerProps = {
  dividerMargin?: number;
};

// Builds off of HorizontalDivider but adds a padding left. Used within lists of items.
export const ActionItemHorizontalDivider = memo(
  function ActionItemHorizontalDividerFn(
    props: ActionItemHorizontalDividerProps
  ) {
    const { dividerMargin } = props;

    return (
      <div style={{ paddingLeft: 62 }}>
        <HorizontalDivider altMargin={dividerMargin || 0} />
      </div>
    );
  }
);
